<template>
    <div class="app_content">
      <div class="header_login">
        <div class="header_inner">
          <el-col :span="8"><router-link :to="{ path: '/' }" class="logo">普惠</router-link></el-col>
          <el-col :span="16" class="login_side_nav">
            <a @click="gobackFirstPage">返回首页</a>
            <em></em>
            <router-link :to="{path:'login'}"><span>已有账号？立即登录</span></router-link>
          </el-col>
        </div>
      </div><!-- header END -->
      <!-- center main -->
        <div class="forgetpwd">
          <el-form ref="form" :model="form" :rules="findPasswordRules">
            <h3 class="title_regist">设置新密码</h3>
            <el-row class="inputs">
                <el-col :span="16">
                  <el-form-item label="您的密码:" prop="newPwd" labelWidth="400px">
                  <el-input type="password" v-model="form.newPwd" placeholder="请输入您的密码"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row class="inputs">
                <el-col :span="16">
                  <el-form-item label="确认密码:" prop="affirmPwd" labelWidth="400px">
                  <el-input  type="password" v-model="form.affirmPwd" placeholder="请确认您的密码"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row class="inputs">
                <el-col :span="2" :offset="10">
                    <el-button class="btn_regist" v-on:click="backLong">取消</el-button>
                </el-col>
                <el-col :span="12">
                    <el-button type="primary" class="btn_regist"  v-on:click="onSubmit">确认</el-button>
                </el-col>
            </el-row>
          </el-form>
        </div><!-- changepwd END -->
    </div>
</template>
<script>
    import {reqChangePwd} from '../api/webUser-api'
    import { Validator } from 'vee-validate';
    const dictionary = {
        zh_CN: {
            attributes:{
                password:'密码',
                affirmPwd:'密码'
            }
        }
    };
    Validator.updateDictionary(dictionary);
    export default {

        data () {
            return {
                form: {
                    newPwd: '',
                    affirmPwd: ''
                },
              findPasswordRules: {
                newPwd: [
                  {required: true, message: '请输入密码', trigger: 'blur'},
                  {
                    pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
                    message: '密码由字母和数字组成6到16个字符',
                    trigger: 'blur'
                  },
                ],
                affirmPwd: [
                  {required: true,message: '请输入确认密码', trigger: 'blur'},
                ],
              }
            }
        },
        methods: {
          gobackFirstPage:function () {
            this.$store.dispatch('showHF');
            this.$router.push({path:'/'});
          },
            backLong(){
                this.$router.push({name:'login'});
            },
            onSubmit(){
                let that=this;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$message({
                            message: '请填写符合规则的信息',
                            type: 'warning'
                        });
                        return false;
                    }
                  this.$refs.form.validate((valid) => {
                    if (valid) {
                      reqChangePwd({
                        phoneNumber: that.$route.query.phoneNumber,
                        newPwd:that.form.newPwd,
                        affirmPwd:that.form.affirmPwd,
                      }).then((res)=>{
                        if(res.data.data===1){
                          this.$message({
                            message: '重置成功，请重新登录',
                            type: 'success'
                          });
                          this.$router.push({name:'login'});
                        }else if(res.data.code===3){
                          this.$message({
                            message: '两次密码输入不一致,请重新输入',
                            type: 'error'
                          });
                          that.form.newPwd='';
                          that.form.affirmPwd='';
                        }else {
                          this.$message({
                            message: '重置失败',
                            type: 'error'
                          });
                        }
                      })

                    }
                  });

                }).catch(() => {
                    // something went wrong (non-validation related).
                });

            }
        },
        mounted(){
          this.$store.dispatch('hideHF');
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ChangePwd.vue